// Libraries
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

/**********
 ** Component: IconArrowDown
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconArrowDown = () => {
	return (
		<Figure xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 56 56">
			<path
				fill="none"
				stroke="#7c838a"
				stroke-linecap="round"
				stroke-linejoin="round"
				stroke-width="2"
				d="M23.5 25.5l4.5 5 4.5-5"
			/>
		</Figure>
	);
};

const Figure = styled.svg`
	display: flex;
	flex-direction: row;
	width: ${rem('56px')};
	height: ${rem('56px')};
`;

export default IconArrowDown;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-arrow-down.jsx